import ArticleListTabs from './article-list-tabs';

const articleListTabsConfig = {
  name: 'articleListTabs',
  class: ArticleListTabs,
  querySelector: {
    tablist: '.article-list-tabs__tablist',
  },
  querySelectorAll: {
    panels: '.article-list-tabs__panel',
    tabs: '.article-list-tabs__tablist > li',
  },
  options: {
    moreTabClass: 'article-list-tabs__tablist__moretab',
    isTearDownClass: 'article-list-tabs--is-teardown',
    isLoadedClass: 'article-list-tabs--is-loaded',
  },
};

export default articleListTabsConfig;

